import React from 'react';

const classNames = require('classnames');

interface Props {
  slug?: string;
  narrow?: boolean;
  caption?: string;
  jumplinkSlug?: string;
}

export default class VideoEmbed extends React.Component<Props, null> {

  slug() {
    return `https://www.youtube.com/embed/${this.props.slug}`;
  }

  render() {
    if (!this.props.slug) return null;

    const classes = classNames(
      'video-embed',
      { 'video-embed--narrow': this.props.narrow },
    );

    return (
      <div
        className={classes}
        id={this.props.jumplinkSlug || null}
      >
        <div className="video-embed__inner">
          <iframe
            src={this.slug()}
            title={this.props.caption}
            frameBorder="0"
            allowFullScreen
          />
        </div>
        {this.props.caption &&
          <div className="video-embed__caption">
            {this.props.caption}
          </div>
        }
      </div>
    );
  }
}
